/**
 * App - Main Application Component
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './Components/Toast/Toast';
import LogoutHandler from './Components/LogoutHandler/LogoutHandler';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import './App.css';

// Layout Components
import Header from './Components/Header/header';
import Footer from './Components/Footer/footer';
import RocMasterData from './Pages/ROCMasterData/RocMasterData';

// Public Pages
import Home from './Components/Home/Home';
import LoginPage from './Pages/LoginPage/LoginPage';
import SignInPage from './Pages/SignInPage/SignInPage';
import OTPPage from './Pages/OTPPage/OTPPage';
import ServicesPage from './Pages/ServicesPage/ServicesPage';
import ServiceDetailsPage from './Pages/ServiceDetailsPage/ServiceDetailsPage';
import ContactUs from './Components/ContactUs/ContactUs';

// Protected Pages
import OrdersPage from './Pages/OrdersPage/OrdersPage';
import OrderDetailPage from './Pages/OrderDetailPage/OrderDetailPage';
import DocumentsPage from './Pages/DocumentsPage/DocumentsPage';
import UploadDocumentsPage from './Pages/UploadDocumentsPage/UploadDocumentsPage';

// Admin Pages
import AdminDashboard from './Components/AdminDashboard/AdminDashboard';

// Feature Pages
import Registration from './Components/Registration/Registration';
import Funding from './Components/Funding/Funding';
import Compliance from './Components/Compliance/Compliance';
import NewUIApp from './new-ui/NewUIApp';

// Layout wrapper to conditionally show header/footer
function AppLayout({ children }) {
  const location = useLocation();
  const authPages = ['/login', '/signin', '/otp'];
  const isNewUI = location.pathname.startsWith('/new-ui');
  const isAuthPage = authPages.some(path => location.pathname.startsWith(path));

  return (
    <div className="App">
      {/* {!isAuthPage && !isNewUI && <Header />} */}
      <main className="main-content">
        {children}
      </main>
      {/* {!isAuthPage && !isNewUI && <Footer />} */}
    </div>
  );
}

// App Routes
function AppRoutes() {
  return (
    <Routes>
      {/* New UI routes */}
      <Route path="*" element={<NewUIApp />} />
      
      {/* Public Routes */}
      {/* <Route path="/login" element={<LoginPage />} /> */}
      {/* <Route path="/signin" element={<SignInPage />} /> */}
      {/* <Route path="/otp" element={<OTPPage />} /> */}
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/service/:slug" element={<ServiceDetailsPage />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/roc-master-data" element={<RocMasterData />} /> 
      
      {/* Feature Pages (Public) */}
      <Route path="/registration" element={<Registration />} />
      <Route path="/funding" element={<Funding />} />
      <Route path="/compliance" element={<Compliance />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      {/* /profile and /myProfile are served by the new-ui ProfilePage via the
          catch-all NewUIApp route — the legacy Home stub no longer claims them. */}
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <OrdersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/order/:orderId"
        element={
          <ProtectedRoute>
            <OrderDetailPage />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/documents"
        element={
          <ProtectedRoute>
            <DocumentsPage />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/upload-documents"
        element={
          <ProtectedRoute>
            <UploadDocumentsPage />
          </ProtectedRoute>
        }
      />
      
      {/* Admin Routes */}
      <Route
        path="/admin-dashboard"
        element={
          <ProtectedRoute requiredRole={['admin', 'super_admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

// Main App Component
function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <LogoutHandler />
        <Router>
          <AppLayout>
            <AppRoutes />
          </AppLayout>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
